import styled from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'
import { BasketBoostSVGLarge } from '@src/components/SVGS/BasketBoostSVGLarge'

export const SingleDiscountContainer = styled.div<{ isAddOn?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 12px;
  border-radius: 8px;
  min-width: 260px;
  max-width: 260px;
  background-color: ${({ theme }) => theme.colors.brandForeground};
  margin-right: 16px;
  height: 96px;
  border: 2px dashed
    ${({ theme, isAddOn }) =>
      isAddOn ? theme.colors.brand : theme.colors.discount};

  @media (min-width: ${breakpoints.tablet}px) {
    min-width: 350px;
    padding: 0 16px;
  }
`

export const CouponAndTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const CouponLargeCircle = styled.div<{ isAddOn?: boolean }>`
  display: flex;
  width: 60px;
  height: 60px;
  flex-shrink: 0; /* Prevent squashing in flex container */
  background-color: ${({ theme, isAddOn }) =>
    isAddOn ? theme.colors.brand : theme.colors.discount};
  border-radius: 48px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (min-width: ${breakpoints.tablet}px) {
    width: 60px;
    height: 60px;
  }
`

export const CouponCircleText = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 700;
  color: #fff;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 18px;
  }
`

export const CouponSmallCircle = styled.div`
  display: flex;
  width: 6px;
  height: 6px;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  top: 7px;
`

export const TitleAndTermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 12px;
`

export const DiscountText = styled.span<{ isAddOn?: boolean }>`
  font-size: 14px;
  font-weight: 700;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.2em;
  max-height: 2.4em; /* 2 * line-height */

  color: ${({ theme, isAddOn }) =>
    isAddOn ? theme.colors.brand : theme.colors.discount};

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 16px;
    line-height: 1.2em;
    max-height: 2.4em;
  }
`

export const TermsText = styled.span`
  font-size: 12px;
  font-weight: 400;

  color: ${({ theme }) => theme.colors.darkText};

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 14px;
  }
`
export const StyledAddOnItemsSVG = styled(BasketBoostSVGLarge)``
